<template>
  <div class="boy_warp">
    <!-- <el-card style="height:100%"> -->
    <p>适龄劳动人口数占比</p>
    <div ref="echartsINof" style="height:100%"></div>
    <!-- </el-card> -->
  </div>
</template>

<script>
import { laoDongPress } from "@/network";
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {
    this.handEchart();
  },
  methods: {
    getInfoData() {},
    handEchart() {
      let myechart = this.$echarts.init(this.$refs.echartsINof);
      let option = {
        tooltip: {
          trigger: "item",
        },
        legend: {
          // orient: "vertical",
          // left: "right",
          // icon: "circle",
          top: 10,
          itemWidth: 20,
          itemHeight: 20,
        },
        series: [
          {
            // name: "访问来源",
            type: "pie",
            radius: "50%",
            center: ["50%", "50%"],
            avoidLabelOverlap: false,
            labelLine: {
              show: true,
            },
            data: [
              {
                value: 1548,
                name: "第三产业",
                label: {
                  formatter: [
                    "{title|{b}}{abg|}",
                    "{hr|}",
                    "{weatherHead|税收}{valueHead|24821万元}{rate|26.55% }",
                    ,
                  ].join("\n"),
                  backgroundColor: "#eee",
                  borderColor: "#777",
                  borderWidth: 1,
                  borderRadius: 4,
                  rich: {
                    title: {
                      align: "center",
                    },
                    abg: {
                      width: "100%",
                      align: "right",
                      height: 25,
                      borderRadius: [4, 4, 0, 0],
                    },
                    Showers: {
                      height: 30,
                      align: "left",
                    },
                    weatherHead: {
                      color: "#333",
                      height: 24,
                      align: "left",
                      fontSize: 11,
                    },
                    hr: {
                      borderColor: "#777",
                      width: "100%",
                      borderWidth: 0.5,
                      height: 0,
                    },
                    value: {
                      width: 20,
                      padding: [0, 20, 0, 30],
                      align: "left",
                    },
                    valueHead: {
                      color: "#333",
                      width: 20,
                      fontSize: 11,
                      padding: [0, 20, 0, 30],
                      align: "center",
                    },

                    rate: {
                      color: "#fff",
                      backgroundColor: "#4C5058",
                      padding: [3, 2],
                      borderRadius: 4,
                      align: "right",
                    },
                  },
                },
              },
              {
                value: 735,
                name: "第一产业",
                label: {
                  formatter: [
                    "{title|{b}}{abg|}",
                    "{hr|}",
                    "{weatherHead|税收}{valueHead|24821万元}{rate|26.55% }",
                    ,
                  ].join("\n"),
                  backgroundColor: "#eee",
                  borderColor: "#777",
                  borderWidth: 1,
                  borderRadius: 4,
                  rich: {
                    title: {
                      align: "center",
                    },
                    abg: {
                      width: "100%",
                      align: "right",
                      height: 25,
                      borderRadius: [4, 4, 0, 0],
                    },
                    Showers: {
                      height: 30,
                      align: "left",
                    },
                    weatherHead: {
                      color: "#333",
                      height: 24,
                      align: "left",
                      fontSize: 11,
                    },
                    hr: {
                      borderColor: "#777",
                      width: "100%",
                      borderWidth: 0.5,
                      height: 0,
                    },
                    value: {
                      width: 20,
                      padding: [0, 20, 0, 30],
                      align: "left",
                    },
                    valueHead: {
                      color: "#333",
                      width: 20,
                      fontSize: 11,
                      padding: [0, 20, 0, 30],
                      align: "center",
                    },

                    rate: {
                      color: "#fff",
                      backgroundColor: "#4C5058",
                      padding: [3, 2],
                      borderRadius: 4,
                      align: "right",
                    },
                  },
                },
              },
              {
                value: 510,
                name: "第二产业",
                label: {
                  formatter: [
                    "{title|{b}}{abg|}",
                    "{hr|}",
                    "{weatherHead|税收}{valueHead|24821万元}{rate|26.55% }",
                    ,
                  ].join("\n"),
                  backgroundColor: "#eee",
                  borderColor: "#777",
                  borderWidth: 1,
                  borderRadius: 4,
                  rich: {
                    title: {
                      align: "center",
                    },
                    abg: {
                      width: "100%",
                      align: "right",
                      height: 25,
                      borderRadius: [4, 4, 0, 0],
                    },
                    Showers: {
                      height: 30,
                      align: "left",
                    },
                    weatherHead: {
                      color: "#333",
                      height: 24,
                      align: "left",
                      fontSize: 11,
                    },
                    hr: {
                      borderColor: "#777",
                      width: "100%",
                      borderWidth: 0.5,
                      height: 0,
                    },
                    value: {
                      width: 20,
                      padding: [0, 20, 0, 30],
                      align: "left",
                    },
                    valueHead: {
                      color: "#333",
                      width: 20,
                      fontSize: 11,
                      padding: [0, 20, 0, 30],
                      align: "center",
                    },

                    rate: {
                      color: "#fff",
                      backgroundColor: "#4C5058",
                      padding: [3, 2],
                      borderRadius: 4,
                      align: "right",
                    },
                  },
                },
              },
            ],
          },
        ],
      };
      myechart.setOption(option);
    },
  },
};
</script>

<style lang="less">
.boy_warp {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .el-card__body {
    height: 100%;
  }
}
</style>
